import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'
import brandLogo from '../images/Small Logo.png'


const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
        @keyframes fadeInUp {from {opacity: 0;
transform: translateY(10px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation, .navigation-logo, .navigation-logo-icon, .navigation-link, .navigation-toggle, .navigation-mobile, .navigation-mobile-panel, .navigation-mobile-link {
  transition: none;
}
.navigation-mobile-link {
  animation: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="navigation-container6">
        <div className="navigation-container7">
          <Script
            html={`<script defer data-name="navigation">
(function(){
  // Navigation functionality
  const navigation = document.getElementById("navigation")
  const navigationToggle = document.getElementById("navigationToggle")
  const navigationMobile = document.getElementById("navigationMobile")
  const navigationMobileClose = document.getElementById("navigationMobileClose")
  const navigationMobileBackdrop = navigationMobile?.querySelector(
    ".navigation-mobile-backdrop"
  )

  let lastScrollY = window.scrollY

  // Handle scroll effects
  function handleScroll() {
    const currentScrollY = window.scrollY

    // Add scrolled class for backdrop effect
    if (currentScrollY > 10) {
      navigation.classList.add("scrolled")
    } else {
      navigation.classList.remove("scrolled")
    }

    // Hide/show navigation on scroll
    if (currentScrollY > lastScrollY && currentScrollY > 100) {
      navigation.classList.add("scroll-down")
      navigation.classList.remove("scroll-up")
    } else {
      navigation.classList.remove("scroll-down")
      navigation.classList.add("scroll-up")
    }

    lastScrollY = currentScrollY
  }

  // Throttled scroll handler
  let scrollTimeout
  window.addEventListener("scroll", () => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout)
    }
    scrollTimeout = setTimeout(handleScroll, 10)
  })

  // Mobile menu toggle
  function toggleMobileMenu() {
    const isActive = navigationMobile.classList.contains("active")

    if (isActive) {
      closeMobileMenu()
    } else {
      openMobileMenu()
    }
  }

  function openMobileMenu() {
    navigationMobile.classList.add("active")
    navigationToggle.setAttribute("aria-expanded", "true")
    document.body.style.overflow = "hidden"

    // Focus the close button for accessibility
    setTimeout(() => {
      navigationMobileClose.focus()
    }, 300)
  }

  function closeMobileMenu() {
    navigationMobile.classList.remove("active")
    navigationToggle.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""

    // Return focus to toggle button
    navigationToggle.focus()
  }

  // Event listeners
  navigationToggle?.addEventListener("click", toggleMobileMenu)
  navigationMobileClose?.addEventListener("click", closeMobileMenu)
  navigationMobileBackdrop?.addEventListener("click", closeMobileMenu)

  // Close mobile menu on escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && navigationMobile.classList.contains("active")) {
      closeMobileMenu()
    }
  })

  // Close mobile menu when clicking on navigation links
  const mobileLinks = document.querySelectorAll(".navigation-mobile-link")
  mobileLinks.forEach((link) => {
    link.addEventListener("click", closeMobileMenu)
  })

  // Handle window resize
  function handleResize() {
    const isActuallyMobile = window.innerWidth <= 991 || 
                            (window.innerHeight <= 500 && window.matchMedia("(orientation: landscape)").matches)
    
    if (!isActuallyMobile && navigationMobile.classList.contains("active")) {
      closeMobileMenu()
    }
  }

  window.addEventListener("resize", handleResize)
  window.addEventListener("orientationchange", () => {
    setTimeout(handleResize, 200)
  })

  // Initialize scroll state
  handleScroll()

  // Fix for orientation change
  let orientationChangeTimeout
  window.addEventListener("orientationchange", () => {
    clearTimeout(orientationChangeTimeout)
    orientationChangeTimeout = setTimeout(() => {
      // Force re-check of navigation state
      const toggle = document.getElementById("navigationToggle")
      const mobile = document.getElementById("navigationMobile")
      
      if (toggle && mobile) {
        // Ensure elements are properly displayed
        const style = window.getComputedStyle(toggle)
        if (style.display === 'none') {
          toggle.style.display = 'flex'
        }
      }
    }, 300)
  })

  // Smooth scroll behavior for anchor links
  const navigationLinks = document.querySelectorAll(
    ".navigation-link, .navigation-mobile-link"
  )
  navigationLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href")
      if (href && href.startsWith("#")) {
        e.preventDefault()
        const target = document.querySelector(href)
        if (target) {
          const offset = navigation.offsetHeight + 20
          const targetPosition = target.offsetTop - offset

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          })

          if (navigationMobile.classList.contains("active")) {
            closeMobileMenu()
          }
        }
      }
    })
  })

  // CTA button handlers
  const ctaButtons = document.querySelectorAll(
    ".navigation-cta, .navigation-mobile-cta .btn"
  )
  ctaButtons.forEach((button) => {
    button.addEventListener("click", () => {
      // Add your inquiry form logic here
      console.log("Request Inquiry clicked")

      // Example: Scroll to contact form or open modal
      const contactForm = document.querySelector("#contact-form, #inquiry-form")
      if (contactForm) {
        contactForm.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      }

      if (navigationMobile.classList.contains("active")) {
        closeMobileMenu()
      }
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <nav id="navigation" className="navigation">
        <div className="navigation-container">
          <a href="/">
            <div aria-label="Nature Ready - Home" className="navigation-logo">
              <div className="navigation-logo-icon" style={{ borderRadius: 0 }}>
                <img src={brandLogo} alt="Nature Ready Logo" width="54" height="54"/>
              </div>

              <span className="navigation-logo-text">Nature Ready</span>
            </div>
          </a>
          <div className="navigation-menu">
            <a href="/">
              <div className="navigation-link">
                <span>Home</span>
              </div>
            </a>
            <a href="/product-gallery">
              <div className="navigation-link">
                <span>Product Gallery</span>
              </div>
            </a>
            <a href="/inquiry-custom-order">
              <div className="navigation-link">
                <span>
                  {' '}
                  Inquiry &amp; Custom Order
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </div>
            </a>
            <a href="/about-us">
              <div className="navigation-link">
                <span>About Us</span>
              </div>
            </a>
          </div>
          <a href="/inquiry-custom-order" className="btn btn-primary">
            Request Inquiry
          </a>
          <button
            id="navigationToggle"
            aria-label="Toggle navigation menu"
            aria-expanded="false"
            className="navigation-toggle"
          >
            <span
              id="navigationToggleIcon"
              className="navigation-navigation-toggle-icon"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 5h16M4 12h16M4 19h16"
                ></path>
              </svg>
            </span>
          </button>
          <div id="navigationMobile" className="navigation-mobile">
            <div className="navigation-mobile-backdrop"></div>
            <div className="navigation-mobile-panel">
              <div className="navigation-mobile-header">
                <a href="/">
                  <div
                    aria-label="Nature Ready - Home"
                    className="navigation-mobile-logo"
                  >
                    <div className="navigation-logo-icon" style={{ borderRadius: 0 }}>
                      <img src={brandLogo} alt="Nature Ready Logo" width="32" height="32"/>
                    </div>
                    <span className="navigation-logo-text">Nature Ready</span>
                  </div>
                </a>
                <button
                  id="navigationMobileClose"
                  aria-label="Close navigation menu"
                  className="navigation-mobile-close"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M18 6L6 18M6 6l12 12"
                    ></path>
                  </svg>
                </button>
              </div>
              <div className="navigation-mobile-content">
                <div className="navigation-mobile-links">
                  <a href="/">
                    <div className="navigation-mobile-link">
                      <span>Home</span>
                    </div>
                  </a>
                  <a href="/product-gallery">
                    <div className="navigation-mobile-link">
                      <span>Product Gallery</span>
                    </div>
                  </a>
                  <a href="/inquiry-custom-order">
                    <div className="navigation-mobile-link">
                      <span>Inquiry &amp; Custom Order</span>
                    </div>
                  </a>
                  <a href="/about-us">
                    <div className="navigation-mobile-link">
                      <span>About Us</span>
                    </div>
                  </a>
                </div>
                <div className="navigation-mobile-cta">
                  <a href="/inquiry-custom-order" className="btn btn-primary">
                    Request Inquiry
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Navigation
